import { Stack, SxProps, Theme, useTheme } from "@mui/material";
import { isNil } from "lodash-es";
import { Moment } from "moment";

import InlineUser from "@/common/components/Entity/User/InlineUser";
import { DATETIME_FORMATS } from "@/common/constants/common";
import { renderIf } from "@/common/helpers/render/renderIf";
import { EntityChangedByInfoFromDto } from "@/common/ts/dto";
import { GeneralByWhoDto } from "@/core/api/generated/v1";
import { ResponsiveStyleValueCustom } from "@/theme/types";

import Datetime from "../Datetime/Datetime";
import GeneralByWhoDisplay from "../Entity/General/Display/GeneralByWhoDisplay";

export type Entity = EntityChangedByInfoFromDto & Record<string, any>;

export interface EntityChangedByInfoDisplayProps {
  dateFormat?: string | null | undefined;
  datetime: string | Moment | null | undefined;
  userId: string | null | undefined;
  who?: GeneralByWhoDto | null;
  direction?: ResponsiveStyleValueCustom<"row" | "column">;
  sx?: SxProps<Theme>;
}

/** Shows who changed the entity */
export default function EntityChangedByInfoDisplay({
  dateFormat = DATETIME_FORMATS.DISPLAY_DATETIME,
  datetime,
  userId,
  who,
  direction = "row",
  sx,
}: EntityChangedByInfoDisplayProps) {
  const theme = useTheme();
  const isMobile = theme.breakpoints.down("md");

  return (
    <Stack
      sx={{
        ...(direction === "row" && { alignItems: "center", flexWrap: "wrap" }),
        ...(direction === "column" && { justifyContent: "flex-start", alignItems: "flex-start" }),
        ...sx,
      }}
      direction={direction}
      gap={direction === "row" ? 1 : 0}
    >
      <Datetime
        direction={isMobile ? "column" : "row"}
        datetime={datetime}
        format={dateFormat}
        withDurationFromNow
      />

      {renderIf()
        .if(!isNil(who))
        .then(<GeneralByWhoDisplay who={who} />)
        .else(<InlineUser userId={userId} withAvatar />)
        .render()}
    </Stack>
  );
}
